
import { defineComponent } from "vue";
import CreateEditDialog from "@/components/controls/catalogueGrid/CreateEditDialog.vue";
import mountComponentMixin from "@/mixins/MountComponentMixin";
import DecimalControl from "@/components/controls/base/DecimalControl.vue";
import TextControl from "@/components/controls/base/TextControl.vue";
//import CatalogueSelectControl from "@/components/controls/base/CatalogueSelectControl.vue";
import IntegerControl from "@/components/controls/base/IntegerControl.vue";

export default defineComponent({
  components: {
    CreateEditDialog,
    DecimalControl,
    TextControl,
    //CatalogueSelectControl,
    IntegerControl,
  },
  mixins: [mountComponentMixin],
  props: {
    saveModelCallback: { required: true },
  },
  computed: {
    shipmentVolume: function () {
      const model = this.dialog().createEditModel;
      return model.volume + model.margin;
    },
  },
  methods: {
    dialog() {
      return this.$refs.dialog as any;
    },
    open(model: any, editType: any) {
      this.dialog().open(model, editType);
    },
    close() {
      this.dialog().close();
    },
    save() {
      this.dialog().save();
    },
    onShown(model: any) {
      (this as any).mountComponent(
        "components/journals/PlanShipmentJournal/PlanShipmentNomenclaturePropertySubCatalogueGrid.vue",
        (this as any).nomenclaturePropertySubGridDomId,
        {
          parentModel: model,
        }
      );
    },
    beforeUnmount() {
      (this as any).unmountComponent(
        (this as any).nomenclaturePropertySubGridDomId
      );
    },
  },
  data() {
    return {
      nomenclaturePropertySubGridDomId:
        "PlanShipmentNomenclatureCreateEditDialog_nomenclaturePropertySubGridDomId",
    };
  },
});
